// our components
import '../../section-specific/student-medical/quote-form_student-medical';
import '../../components/forms/component.quote-form-age-modal';

import MainVue from '../../main-vue';
import quoteFormMixin from '../../quote-form-mixin';

new MainVue({
    el: '#app',
    mixins: [quoteFormMixin]
});

new MainVue({
    el: '#home-card-blocks-and-guide',
    data: function() {
        return {
            affiliateJ1Visa: ibJS.affiliateJ1Visa,
            affiliateStudyAbroad: ibJS.affiliateStudyAbroad,
            affiliateTripInsurance: ibJS.affiliateTripInsurance,
            affiliateSchengenVisa: ibJS.affiliateSchengenVisa,
            affiliateDental: ibJS.affiliateDental,
            affiliateIndividualMedical: ibJS.affiliateIndividualMedical,
            affiliateGroupMedical: ibJS.affiliateGroupMedical,
            affiliateEvacRepatriation: ibJS.affiliateEvacRepatriation,
            isFAQItemVisible: null,
        }
    },
    methods: {
        getIntroCardsCount: function(){
            //Initiate counter
            var counter = 0;

            //International Student (F Visa) Section
            if(window.globalLanguage.section == "student") {
                //Arrays of true/false block section values
                var sectionCards = [this.affiliateJ1Visa,this.affiliateStudyAbroad,this.affiliateTripInsurance,this.affiliateSchengenVisa];
            }
            //OPT Section
            else if(window.globalLanguage.section == "opt") {
                var sectionCards = [this.affiliateDental,this.affiliateIndividualMedical,this.affiliateSchengenVisa,this.affiliateTripInsurance];
            }
            //Exchange Visitors (J Visa) Section
            else if(window.globalLanguage.section == "j1Visa") {
                var sectionCards = [this.affiliateSchengenVisa,this.affiliateEvacRepatriation,this.affiliateGroupMedical,this.affiliateJ1Visa];
            }

            //Loop and count true/false values
            sectionCards.forEach(v => v ? counter++ : v);

            return counter;
        },
        getIntroCardsModifierClass(itemCount, masterClass) {
            //Return modifier class name to adjust intro card styles
            if(itemCount==1) {
                return masterClass + "--one";
            }
            else if(itemCount==2) {
                return masterClass + "--two";
            }
            else if(itemCount==3) {
                return masterClass + "--three";
            }
            else if(itemCount==4) {
                return masterClass + "--four";
            }
        },
        toggleFAQItem: function(value) {
            
            if(this.isFAQItemVisible!==value){
                this.isFAQItemVisible = value;
            }
            else {
                this.isFAQItemVisible = null;
            }
        
        },   
    }
});